<template>
  <v-container fluid>
    <v-card>
      <v-card-title
        primary-title
        style="padding-left: 8px; padding-bottom: 8px"
      >
        <span class="headline mb-0">ＰＤＦファイル送信</span>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="mail.receivers.length === 0 || !valid" @click="send()"
          >送信</v-btn
        >
        <v-btn @click="goToList()">{{ $t('app.buttons.back') }}</v-btn>
      </v-card-actions>
      <v-form ref="form" lazy-validation v-model="valid" value>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs3>
              <remote-autocomplete
                returnObject
                :url="
                  `/buyers/receiver/kv?type=${bl.shippingMode}&buyerCode=${
                    bl.consigneeCode
                  }`
                "
                label="宛先アドレス"
                v-model="receiver"
                append-outer-icon="add"
                clearable
                @click:append-outer="appendReceiver()"
                @obtainedData="getPreviousReceiver"
              />
            </v-flex>
            <v-flex xs12>
              <v-chip
                class="ma-2"
                @input="close(item)"
                v-for="item in mail.receivers"
                :key="item.email"
                close
                color="orange"
                outline
              >
                <span
                  class="showChip"
                  :title="
                    item.fullName +
                      ' : ' +
                      item.email +
                      (!item.remark ? '' : ':' + item.remark)
                  "
                >
                  {{
                    item.fullName +
                      ' : ' +
                      item.email +
                      (!item.remark ? '' : ':' + item.remark)
                  }}
                </span>
              </v-chip>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                :rules="[
                  (v) =>
                    !v ||
                    (!!v && v.length < 50) ||
                    '件名を50文字以下にしてください',
                ]"
                required
                label="件名"
                clearable
                v-model="mail.title"
              />
            </v-flex>
            <v-flex xs4>
              <v-text-field
                label="INV No."
                disabled
                :value="
                  bl.invoices && bl.invoices.map((i) => i.invNo).join(' / ')
                "
              />
            </v-flex>
            <v-flex xs4>
              <remote-autocomplete
                disabled
                label="Final Port."
                url="ports/kv?tradeType=EXPORT"
                :value="bl.dischargePortCode"
              />
            </v-flex>
            <v-flex xs4>
              <v-text-field
                label="Our Book No."
                disabled
                :value="
                  bl.invoices && bl.invoices.map((i) => i.bkNo).join(' / ')
                "
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field
                label="S/I No"
                disabled
                :value="
                  bl.invoices && bl.invoices.map((i) => i.siNo).join(' / ')
                "
              />
            </v-flex>
            <v-flex xs4>
              <v-text-field label="B/L No." disabled :value="bl.blNo" />
            </v-flex>
            <v-flex xs4>
              <v-text-field label="B/L DATE" disabled :value="bl.blDate" />
            </v-flex>
            <v-flex xs4>
              <remote-autocomplete
                disabled
                label="バイヤー名称"
                url="buyers/code/kv"
                :value="bl.consigneeCode"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs4>
              <remote-autocomplete
                disabled
                label="積出港"
                url="ports/kv?tradeType=EXPORT"
                :value="bl.originPortCode"
              />
            </v-flex>
            <v-flex xs4>
              <remote-autocomplete
                disabled
                label="仕向港"
                url="ports/kv?tradeType=EXPORT"
                :value="bl.dischargePortCode"
              />
            </v-flex>
            <v-flex xs12>
              <v-textarea
                :rules="[
                  (v) =>
                    !v ||
                    (!!v && v.length < 200) ||
                    '備考を200文字以下にしてください',
                ]"
                label="備考"
                v-model="mail.remark"
              />
            </v-flex>
            <v-flex xs12>
              <label style="font-size: 12px">資料</label>
              <ul class="doc">
                <li
                  @click="$downloadTdocFile(file)"
                  v-for="file in attachments"
                  :key="file.fileOssId"
                >
                  {{ file.name }}
                </li>
              </ul>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      receiver: {},
      valid: false,
      bl: {},
      mail: {
        receivers: [],
        title: null,
        remark: '',
      },
      selected: [],
      currentInvoice: {},
      attachments: [],
      inited: false,
    }
  },
  methods: {
    validData() {
      //状态是CONFIRMED
      if (this.bl.status !== 'CONFIRMED') {
        this.$message('', 'ステータスが一時保存になっていますので、送信不可')
        return false
      }
      //每一个invoice至少一个附件
      for (var i = 0; i < this.bl.invoices.length; i++) {
        if (
          !this.bl.invoices[i].attachments ||
          this.bl.invoices[i].attachments.length === 0
        ) {
          this.$message(
            '',
            'invoice毎に少なくとも一つPDFファイルが添付されていることをご確保ください。'
          )
          return false
        }
      }
      //AWB至少一个附件
      if (!this.bl.attachments || this.bl.attachments.length === 0) {
        this.$message(
          '',
          'BLファイルが添付されていません。少なくとも1つ添付してください。'
        )
        return false
      }
      return true
    },
    doSendMail() {
      this.$http
        .post(`/tdoc/mails/create`, {
          blId: this.$route.query.id,
          toAddress: this.mail.receivers.map((r) => r.email),
          toNames: this.mail.receivers.map((r) => r.fullName),
          showInfos: this.mail.receivers.map((r) => r.fullName + ':' + r.email),
          title: this.mail.title,
          remark: this.mail.remark,
          senderName: this.$store.getters.user.fullName,
          senderMail: this.$store.getters.user.email,
        })
        .then((res) => {
          this.$message('', '送信できました。', 'SUCCESS')
        })
        .catch((err) => {
          this.$message('', '送信が失敗になりました。', 'ERROR')
        })
    },
    send() {
      if (!this.validData()) return
      // console.log(this.$store.getters.user.name)
      this.$http
        .get(`/tdoc/mails/check-status?blNo=${this.bl.blNo}`)
        .then((res) => {
          if (res.data) {
            this.$confirm({
              content: '当該データ送信中です。重複送信してよろしいでしょうか',
              action: '確定',
            }).then(() => {
              this.doSendMail()
            })
          } else {
            this.doSendMail()
          }
        })
    },
    goToList() {
      this.$router.push('/t-doc')
    },
    load() {
      this.$http.get(`/tdoc/bls/${this.$route.query.id}`).then((res) => {
        this.bl = res.data
        if (this.bl.attachments) {
          this.attachments = [...this.attachments, ...this.bl.attachments]
        }
        this.bl.invoices.forEach((inv) => {
          if (inv.attachments) {
            this.attachments = [...this.attachments, ...inv.attachments]
          }
        })
      })
    },
    appendReceiver() {
      if (
        this.mail.receivers
          .map((r) => r.email)
          .indexOf(this.receiver.value.email) > -1
      ) {
        this.$message('', 'メールアドレスが既存しています。')
      } else {
        this.mail.receivers.push(this.receiver.value)
        this.receiver = {}
      }
    },
    close(item) {
      this.mail.receivers.forEach((r, index) => {
        if (r.email === item.email) {
          this.mail.receivers.splice(index, 1)
        }
      })
    },
    getPreviousReceiver(data) {
      if (data.length > 0 && !this.inited) {
        this.$http
          .get(`/tdoc/mails/lastRecord?blNo=${this.bl.blNo}`)
          .then((res) => {
            if (res.data) {
              var address = res.data.toAddress.split(';')
              address.forEach((a) => {
                var w = data.find((d) => d.type === a)
                if (w) {
                  this.mail.receivers.push(w.value)
                }
              })
            }
            this.inited = true
          })
      }
    },
  },
  mounted() {
    this.load()
  },
}
</script>

<style scoped>
.lc-ref-no {
  display: flex;
}

.lc-ref-no-split {
  padding: 5px;
  padding-top: 20px;
}

.card-content {
  padding: 5px 15px;
  background: #f0f0f0;
}

.doc {
  margin: 0px;
  padding: 0px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  font-size: 12px;
  padding: 5px 0px;
}

.doc li {
  padding: 2px 0px 2px 25px;
  list-style: none;
  background: transparent url(../../assets/img/pdf.svg) no-repeat;
  background-size: contain;
  cursor: pointer;
}

.showChip {
  max-width: 500px;
  min-width: 400px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
